import React, { useRef } from "react";
import { Line } from "../../../../components/Icons";
import { Button, Divider, Input } from "antd";

const Profile = () => {
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
  };

  return (
    <div className="MainProfilediv">
      <div className="profile">Profile</div>

      <Divider style={{ borderColor: "#525558" }}></Divider>

      <div className="namesection">
        <div className="profileimg">JD</div>

        <div className="inputRow">
          <label>Full Name</label>
          <Input className="inputbox" placeholder="Jane Doe" />
        </div>
      </div>

      <div
        className="uplaodimage"
        onClick={() => fileInputRef.current.click()}
        style={{ cursor: "pointer" }}
      >
        <input
          type="file"
          hidden
          ref={fileInputRef}
          onChange={handleFileChange}
        />

        <div className="avatar">Add Photo</div>
        <div className="or">or</div>
        <div className="avatar">Create Your Avatar</div>
      </div>

      <div className="profile">Account Security</div>

      <Divider style={{ borderColor: "#525558" }}></Divider>

      <div className="SecuritySection">
        <div className="Securitybox">
          <h2>
            Email
            <p>janedoe@test.com</p>
          </h2>
        </div>

        <Button className="securitybtn">Change Email</Button>
      </div>

      <div className="SecuritySection">
        <div className="Securitybox">
          <h2>
            Password
            <p>Change your password to login to your account.</p>
          </h2>
        </div>

        <Button className="securitybtn">Change Password</Button>
      </div>

      <div className="SecuritySection">
        <div className="Securitybox">
          <h2>
            2-step verification
            <p>
              Add an additional layer of security to your account during login.
            </p>
          </h2>
        </div>

        <Button className="securitybtn">Add Verification Method</Button>
      </div>

      <div className="SecuritySection">
        <div className="Securitybox">
          <h2>
            Passkeys
            <p>Securely sign in with on device biometric authentication</p>
          </h2>
        </div>

        <Button className="securitybtn">Add Passkey</Button>
      </div>
    </div>
  );
};

export default Profile;
